import { render, staticRenderFns } from "./Create-Teacher.vue?vue&type=template&id=855455fc&scoped=true"
import script from "./Create-Teacher.vue?vue&type=script&lang=js"
export * from "./Create-Teacher.vue?vue&type=script&lang=js"
import style0 from "./Create-Teacher.vue?vue&type=style&index=0&id=855455fc&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855455fc",
  null
  
)

export default component.exports